<template>
  <UiComponentWrapper class="page">
    <!-- Popup > Suggest Yearly Plan -->
    <Transition
      @enter="onEnter"
      @leave="onLeave"
    >
      <UiComponentWrapper
        v-if="displayTheFirstPopup"
        class="popup"
      >
        <UiComponentWrapper class="inner">
          <UiComponentWrapper class="details">
            <UiComponentIcon type="info" />
            <UiComponentWrapper class="content">
              <UiComponentParagraph class="headline">
                {{
                  $interpolate(props.page.popup1Title, {
                    '%{difference}': wrapWithCurrency(currencySymbol, differenceWithTheSuggestedPlan),
                  })
                }}
              </UiComponentParagraph>
              <UiComponentParagraph>
                {{
                  $interpolate(props.page.popup1Text, {
                    '%{recommendedPlan}': `Pro ${suggestedProPlan.activeContactsLimit}`,
                  })
                }}
              </UiComponentParagraph>
              <UiComponentWrapper class="more">
                <UiComponentWrapper class="current-plan">
                  <UiComponentWrapper class="body">
                    <UiComponentHeading :level="6">
                      Pro {{ currentProPlan.activeContactsLimit }} {{ props.page.filtersMonthly }}
                    </UiComponentHeading>
                    <UiComponentHeading :level="6">
                      {{ wrapWithCurrency(currencySymbol, currentProPlan.priceWhenMonthlyBilled) }}*{{ props.page.proPlanPerMonth }}, {{ props.page.proPlanBilledMonthly }}*
                    </UiComponentHeading>
                  </UiComponentWrapper>
                  <UiComponentWrapper class="footer">
                    <UiComponentWrapper
                      class="progress"
                      :style="{
                        width: `${((currentProPlan.activeContactsLimit) / 1000) * 100}%`,
                      }"
                    />
                  </UiComponentWrapper>
                </UiComponentWrapper>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="arrow"
                  fill="none"
                  height="22"
                  viewBox="0 0 62 22"
                  width="62"
                >
                  <path
                    d="M0.48604 1.4686C0.71412 6.44101 3.73616 10.8948 7.10033 14.0979C10.2649 17.057 14.0567 19.1618 18.1052 20.4126C22.1536 21.6633 26.4586 22.1209 30.678 21.7548C35.6102 21.3277 40.3999 19.894 44.9615 17.8806C49.5801 15.8367 53.9421 13.2132 58.1331 10.3152C58.6462 9.94915 59.1879 9.58308 59.7011 9.21702C60.4709 8.66791 59.7581 7.35618 58.9883 7.90528C54.9399 10.8033 50.749 13.4573 46.3014 15.6232C41.9394 17.7281 37.3493 19.3449 32.6167 20.016C28.5398 20.6261 24.3488 20.4736 20.3289 19.4669C16.4231 18.5212 12.6883 16.7824 9.46666 14.1894C7.8701 12.9082 6.44461 11.4134 5.21869 9.73561C3.8217 7.84427 2.65279 5.64786 2.16812 3.29893C2.05408 2.68882 1.96856 2.10922 1.94005 1.49911C1.85452 0.492421 0.429021 0.49242 0.48604 1.4686Z"
                    fill="white"
                  />
                  <path
                    d="M46.7002 7.57019C49.6938 7.69221 52.7158 7.81424 55.7094 7.93626C56.8213 7.99727 58.0757 8.05828 58.9025 8.94294C59.6152 9.73609 59.8433 10.8953 59.7863 11.963C59.7007 13.5798 58.931 15.0746 58.2468 16.4473C57.8191 17.3015 59.045 18.0946 59.4727 17.21C60.7556 14.617 62.1241 11.3834 60.4705 8.60738C59.6722 7.26513 58.3893 6.68553 56.9638 6.5025C55.4528 6.28896 53.8847 6.31947 52.3452 6.25845C50.4636 6.16694 48.6104 6.10592 46.7288 6.0144C45.7879 6.0144 45.7879 7.53969 46.7002 7.57019Z"
                    fill="white"
                  />
                </svg>
                <UiComponentWrapper class="suggested-plan">
                  <UiComponentWrapper class="body">
                    <UiComponentHeading :level="6">
                      Pro {{ suggestedProPlan.activeContactsLimit }} {{ props.page.filtersYearly }}
                    </UiComponentHeading>
                    <UiComponentHeading :level="6">
                      {{ wrapWithCurrency(currencySymbol, suggestedProPlan.priceWhenYearlyBilled) }}*{{ props.page.proPlanPerMonth }}, {{ props.page.proPlanBilledYearly }}*
                    </UiComponentHeading>
                  </UiComponentWrapper>
                  <UiComponentWrapper class="footer">
                    <UiComponentWrapper
                      class="progress"
                      :style="{
                        width: `${((suggestedProPlan.activeContactsLimit) / 1000) * 100}%`,
                      }"
                    />
                  </UiComponentWrapper>
                </UiComponentWrapper>
              </UiComponentWrapper>
            </UiComponentWrapper>
          </UiComponentWrapper>
          <UiComponentWrapper class="action">
            <AtomButton
              :action="signupOrUpgradeCallToAction.action"
              label="Pricing banner CTA"
              size="l"
              :to="popupCTATo"
              type="secondary"
            >
              {{ signupOrUpgradeCallToAction.slot }}
            </AtomButton>
          </UiComponentWrapper>
          <UiComponentWrapper
            class="close"
            @click="displayTheFirstPopup = false"
          >
            <UiComponentIcon type="x" />
          </UiComponentWrapper>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </Transition>

    <!-- Popup > Suggest Business Plan -->
    <Transition
      @enter="onEnter"
      @leave="onLeave"
    >
      <UiComponentWrapper
        v-if="displayTheSecondPopup"
        class="popup"
      >
        <UiComponentWrapper class="inner">
          <UiComponentWrapper class="details">
            <UiComponentIcon type="info" />
            <UiComponentWrapper class="content">
              <UiComponentParagraph class="headline">
                {{ props.page.popup2Title }}
              </UiComponentParagraph>
              <UiComponentParagraph>
                {{
                  $interpolate(props.page.popup2Text, {
                    '%{dollarSign}': currencySymbol === '$' ? '$' : '',
                    '%{euroSign}': currencySymbol === '€' ? '€' : '',
                  })
                }}
              </UiComponentParagraph>
            </UiComponentWrapper>
          </UiComponentWrapper>
          <UiComponentWrapper class="action">
            <AtomButton
              :action="requestDemoCallToAction.action"
              label="Pricing banner CTA"
              size="l"
              :to="requestDemoCallToAction.to"
              type="secondary"
            >
              {{ requestDemoCallToAction.slot }}
            </AtomButton>
          </UiComponentWrapper>
          <UiComponentWrapper
            class="close"
            @click="displayTheSecondPopup = false"
          >
            <UiComponentIcon type="x" />
          </UiComponentWrapper>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </Transition>

    <!-- Section > Hero -->
    <UiComponentContainer class="hero">
      <UiComponentHeading>{{ props.page.heroTitle }}</UiComponentHeading>
      <UiComponentParagraph>{{ props.page.heroText }}</UiComponentParagraph>
    </UiComponentContainer>

    <!-- Section > Paid Plans -->
    <UiComponentContainer class="paid-plans">
      <UiComponentWrapper class="filters">
        <UiComponentWrapper class="switch">
          <UiComponentWrapper class="toggle">
            <UiComponentParagraph
              :class="{ active: billingMode === 'monthly' }"
              @click="setBillingMode('monthly')"
            >
              {{ props.page.filtersMonthly }}
            </UiComponentParagraph>
            <UiComponentWrapper
              class="widget"
              :class="{ on: billingMode === 'yearly' }"
              @click="toggleBillingMode"
            />
            <UiComponentParagraph
              :class="{ active: billingMode === 'yearly' }"
              @click="setBillingMode('yearly')"
            >
              {{ props.page.filtersYearly }}
            </UiComponentParagraph>
          </UiComponentWrapper>
          <UiComponentWrapper class="discount">
            {{ props.page.filtersSaveUpToFiftyPercent }}
          </UiComponentWrapper>
        </UiComponentWrapper>
        <UiComponentWrapper class="currencies">
          <UiComponentSelect
            :index="currentCurrencyIndex"
            :options="currencies"
            @select:change="changeCurrency"
          />
        </UiComponentWrapper>
      </UiComponentWrapper>
      <UiComponentWrapper class="plans">
        <OrganismSelfServedPlan
          :billing-mode="billingMode"
          :currency="currencySymbol"
          :is-recommended="hasInteractedWithTheCalculator && proPlan.title === bestFitBasedOnCalculator.title"
          :plan="proPlan"
          :wording="wording"
          @mac:change="planChanged"
          @mac:definition:click="goToTheMacCalculator('Anchor clicked', 'Pro Pricing card')"
          @mac:exceeded="billingMode = 'yearly'"
          @mac:recalculate:click="goToTheMacCalculator('Recalculate clicked', 'Pricing card')"
          @mac:slider:interacted="hidePopups"
        />
        <OrganismSalesEnabledPlan
          :is-recommended="hasInteractedWithTheCalculator && businessPlan.title === bestFitBasedOnCalculator.title"
          :plan="businessPlan"
          :wording="wording"
          @mac:recalculate:click="goToTheMacCalculator('Recalculate clicked', 'Pricing card')"
        />
        <OrganismSalesEnabledPlan
          :is-recommended="hasInteractedWithTheCalculator && enterprisePlan.title === bestFitBasedOnCalculator.title"
          :plan="enterprisePlan"
          :wording="wording"
          @mac:recalculate:click="goToTheMacCalculator('Recalculate clicked', 'Pricing card')"
        />
      </UiComponentWrapper>
      <UiComponentWrapper class="mobile-only">
        <UiComponentSelect
          :index="currentCurrencyIndex"
          :options="currencies"
          @select:change="changeCurrency"
        />
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > Active Contacts Calculator -->
    <UiComponentContainer class="active-contacts">
      <UiComponentWrapper class="definition">
        <UiComponentWrapper class="head">
          <UiComponentIcon type="users" />
        </UiComponentWrapper>
        <UiComponentWrapper class="body">
          <UiComponentHeading :level="2">
            {{ props.page.macCalculatorTitle }}
          </UiComponentHeading>
          <UiComponentParagraph>{{ props.page.macCalculatorText }}</UiComponentParagraph>
        </UiComponentWrapper>
        <UiComponentWrapper class="footer">
          <UiComponentIcon type="light" />
          <UiComponentWrapper class="examples">
            <UiComponentParagraph class="title">
              {{ props.page.macCalculatorExample }}
            </UiComponentParagraph>
            <UiComponentWrapper class="list">
              <UiComponentParagraph
                v-for="{ id, value } in props.page.macCalculatorExamples"
                :key="`example-${id}`"
                class="item"
              >
                {{ value }}
              </UiComponentParagraph>
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
      </UiComponentWrapper>
      <UiComponentWrapper class="calculator">
        <UiComponentWrapper class="questions">
          <UiComponentHeading :level="4">
            {{ props.page.macCalculatorEstimateYourMacVolume }}
          </UiComponentHeading>

          <!-- Question 1 -->
          <UiComponentWrapper class="question">
            <UiComponentParagraph>{{ props.page.macCalculatorFirstQuestion }}</UiComponentParagraph>
            <MoleculeRange
              :steps="firstQuestionSteps"
              @change="handleAnswerTo(0, $event)"
            />
          </UiComponentWrapper>

          <!-- Question 2 -->
          <UiComponentWrapper class="question">
            <UiComponentParagraph>{{ props.page.macCalculatorSecondQuestion }}</UiComponentParagraph>
            <MoleculeRange
              :steps="secondQuestionSteps"
              @change="handleAnswerTo(1, $event)"
            />
          </UiComponentWrapper>

          <!-- Question 3 -->
          <UiComponentWrapper class="question">
            <UiComponentParagraph>{{ props.page.macCalculatorThirdQuestion }}</UiComponentParagraph>
            <MoleculeSelect
              :options="thirdQuestionOptions"
              :value="thirdQuestionIndex"
              @change="handleAnswerTo(2, $event)"
            />
          </UiComponentWrapper>

          <!-- Question 4 -->
          <UiComponentWrapper class="question">
            <UiComponentParagraph>{{ props.page.macCalculatorFourthQuestion }}</UiComponentParagraph>
            <MoleculeSelect
              :options="fourthQuestionOptions"
              @change="handleAnswerTo(3, $event)"
            />
          </UiComponentWrapper>
        </UiComponentWrapper>

        <UiComponentWrapper
          :key="`result-in-${currencySymbol}`"
          class="result"
        >
          <Transition
            mode="out-in"
            name="fade"
          >
            <UiComponentWrapper
              v-if="!hasInteractedWithTheCalculator"
              class="inner"
            >
              <UiComponentImage
                v-if="props.page.macCalculatorIllustration"
                :key="`mac-calculator-illustation-${macCalculatorIllustrationSize}-${macCalculatorIllustrationOrientation}`"
                :alt="props.page.macCalculatorIllustration.alt"
                class="illustation"
                :expected-size="macCalculatorIllustrationSize"
                :height="props.page.macCalculatorIllustration.height"
                :orientation="macCalculatorIllustrationOrientation"
                :source="props.page.macCalculatorIllustration.url"
                :width="props.page.macCalculatorIllustration.width"
              />
              <UiComponentParagraph>{{ props.page.macCalculatorCalculateYourCostByAdjustingTheParameters }}</UiComponentParagraph>
            </UiComponentWrapper>
            <UiComponentWrapper
              v-else
              class="inner"
            >
              <UiComponentWrapper class="estimation">
                <UiComponentParagraph>{{ props.page.macCalculatorWeEstimateThatYouWillNeed }}</UiComponentParagraph>
                <UiComponentParagraph>
                  <span class="count">{{ animatedEstimatedMonthlyActiveContacts }}</span>
                  <span class="keyword">{{ props.page.macCalculatorActiveContacts }}</span>
                </UiComponentParagraph>
              </UiComponentWrapper>
              <Transition
                mode="out-in"
                name="fade"
              >
                <UiComponentWrapper
                  :key="`current-plan-${bestFitBasedOnCalculator.title}`"
                  class="plan"
                >
                  <UiComponentParagraph class="name">
                    {{ bestFitBasedOnCalculator.title }}
                  </UiComponentParagraph>

                  <UiComponentWrapper
                    v-if="bestFitBasedOnCalculator.hasCustomPricing"
                    class="type sales-enabled"
                  >
                    {{ props.page.macCalculatorCustomPricing }}
                  </UiComponentWrapper>

                  <UiComponentWrapper
                    v-else-if="bestFitBasedOnCalculator.title.toLowerCase() === 'pro'"
                    class="type self-service"
                  >
                    <UiComponentWrapper class="yearly">
                      <UiComponentParagraph class="price">
                        {{ wrapWithCurrency(currencySymbol, animatedPriceWhenYearlyBilled) }}
                      </UiComponentParagraph>
                      <UiComponentWrapper class="info">
                        <UiComponentParagraph>{{ props.page.macCalculatorPerMonth }}</UiComponentParagraph>
                        <UiComponentParagraph>{{ props.page.macCalculatorBilledYearly }}</UiComponentParagraph>
                      </UiComponentWrapper>
                    </UiComponentWrapper>
                    <UiComponentWrapper
                      v-if="priceWhenMonthlyBilled"
                      class="monthly"
                    >
                      <UiComponentParagraph class="price">
                        {{ wrapWithCurrency(currencySymbol, animatedPriceWhenMonthlyBilled) }}
                      </UiComponentParagraph>
                      <UiComponentWrapper class="info">
                        <UiComponentParagraph>{{ props.page.macCalculatorPerMonth }}</UiComponentParagraph>
                        <UiComponentParagraph>{{ props.page.macCalculatorBilledMonthly }}</UiComponentParagraph>
                      </UiComponentWrapper>
                    </UiComponentWrapper>
                    <UiComponentWrapper
                      v-else
                      class="monthly"
                    >
                      <UiComponentParagraph class="annual-only">
                        {{ props.page.proPlanYearlyBillingOnly }}
                      </UiComponentParagraph>
                    </UiComponentWrapper>
                  </UiComponentWrapper>

                  <UiComponentWrapper
                    v-else
                    class="type free"
                  >
                    <UiComponentParagraph class="price">
                      {{ wrapWithCurrency(currencySymbol, 0) }}
                    </UiComponentParagraph>
                    <UiComponentWrapper class="info">
                      <UiComponentParagraph>{{ props.page.macCalculatorPerMonth }}</UiComponentParagraph>
                      <UiComponentParagraph>{{ props.page.macCalculatorBilledAnnually }}</UiComponentParagraph>
                    </UiComponentWrapper>
                  </UiComponentWrapper>

                  <UiComponentWrapper class="usage">
                    <UiComponentWrapper
                      v-for="
                        { id, icon, text, information } in bestFitBasedOnCalculator.usage.length > 5
                          ? bestFitBasedOnCalculator.usage.slice(0, 5)
                          : bestFitBasedOnCalculator.usage
                      "
                      :key="`feature-${id}`"
                      class="feature"
                      :data-information="information"
                    >
                      <UiComponentIcon :type="icon.name" />
                      <UiComponentHeading
                        as="paragraph"
                        :level="6"
                      >
                        {{ $interpolate(text, {
                          '%{currentActiveContacts}': currentNumberOfActiveContacts,
                        }) }}
                      </UiComponentHeading>
                      <UiComponentIcon
                        v-if="information"
                        type="info"
                        @mouseover="onMouseOver"
                        @mouseout="onMouseOut"
                      />
                    </UiComponentWrapper>
                    <UiComponentWrapper
                      v-if="bestFitBasedOnCalculator.usage.length > 5"
                      class="feature"
                    >
                      <UiComponentIcon type="check" />
                      <UiComponentHeading
                        as="paragraph"
                        :level="6"
                      >
                        {{ props.page.macCalculatorAndMuchMore }}
                      </UiComponentHeading>
                    </UiComponentWrapper>
                  </UiComponentWrapper>

                  <AtomButton
                    action="MAC Calculator Button clicked"
                    :attributes="{
                      label: bestFitBasedOnCalculator.cta.action,
                      mac: estimatedMonthlyActiveContacts,
                      position: 'MAC Calculator',
                      pricing_plan_recommendation: bestFitBasedOnCalculator.title,
                      question_1: firstQuestionInput,
                      question_2: secondQuestionInput,
                      question_3: thirdQuestionOptions[thirdQuestionIndex],
                      question_4: fourthQuestionOptions[fourthQuestionIndex],
                    }"
                    size="l"
                    :to="
                      bestFitBasedOnCalculator.cta.to.startsWith('#')
                        ? localePath('contact')
                        : bestFitTo
                    "
                  >
                    {{ bestFitBasedOnCalculator.cta.slot }}
                    <UiComponentIcon type="arrow-right" />
                  </AtomButton>
                </UiComponentWrapper>
              </Transition>
            </UiComponentWrapper>
          </Transition>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > Free plan -->
    <UiComponentContainer
      class="free-plan"
      :start="2"
      :end="2"
    >
      <UiComponentWrapper class="inner">
        <UiComponentWrapper class="head">
          <UiComponentHeading :level="2">
            {{ props.page.freePlanTitle }}
          </UiComponentHeading>
        </UiComponentWrapper>
        <UiComponentWrapper class="body">
          <UiComponentWrapper
            v-for="{ id, icon, text, information } in props.page.freePlanUsage"
            :key="`free-plan-primary-feature-${id}`"
            class="feature"
            :data-information="information"
          >
            <UiComponentIcon :type="icon.name" />
            <UiComponentHeading
              as="paragraph"
              :level="6"
            >
              {{ text }}
            </UiComponentHeading>
            <UiComponentIcon
              v-if="information"
              type="info"
              @mouseover="onMouseOver"
              @mouseout="onMouseOut"
            />
          </UiComponentWrapper>
        </UiComponentWrapper>
        <UiComponentWrapper class="footer">
          <AtomButton
            :action="getCallToActionByType(props.page.freePlanCta).action"
            label="Column Free CTA"
            size="l"
            :to="getCallToActionByType(props.page.freePlanCta).to"
          >
            {{ getCallToActionByType(props.page.freePlanCta).slot }}
          </AtomButton>
          <UiComponentWrapper class="list">
            <UiComponentWrapper
              v-for="text, index in [...livestormFeatures, props.componentGlobal.freeForever]"
              :key="`free-plan-secondary-feature-${index}`"
              class="feature"
            >
              <UiComponentIcon type="check" />
              <UiComponentHeading
                as="paragraph"
                :level="6"
              >
                {{ text }}
              </UiComponentHeading>
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > Features -->
    <UiComponentContainer class="features">
      <UiComponentHeading :level="2">
        {{ props.page.featureTableTitle }}
      </UiComponentHeading>
      <UiComponentWrapper class="table">
        <UiComponentWrapper
          class="head"
          :style="{ '--bg-color': '#F9FAFB' }"
        >
          <UiComponentWrapper class="inner">
            <UiComponentWrapper class="empty" />
            <UiComponentWrapper class="plan">
              <UiComponentHeading
                as="paragraph"
                :level="4"
              >
                {{ freePlan.title }}
              </UiComponentHeading>
              <AtomButton
                :action="freePlan.cta.action"
                label="Grid Free CTA Top"
                size="l"
                :to="freePlan.cta.to"
                type="secondary"
              >
                <span>{{ freePlan.cta.slot }}</span>
                <UiComponentIcon type="arrow-right" />
              </AtomButton>
            </UiComponentWrapper>
            <UiComponentWrapper class="plan">
              <UiComponentHeading
                as="paragraph"
                :level="4"
              >
                {{ proPlan.title }}
              </UiComponentHeading>
              <AtomButton
                :action="proPlan.cta.action"
                label="Grid Pro CTA Top"
                size="l"
                :to="proPlan.cta.to"
                type="secondary"
              >
                <span>{{ proPlan.cta.slot }}</span>
                <UiComponentIcon type="arrow-right" />
              </AtomButton>
            </UiComponentWrapper>
            <UiComponentWrapper class="plan">
              <UiComponentHeading
                as="paragraph"
                :level="4"
              >
                {{ businessPlan.title }}
              </UiComponentHeading>
              <AtomButton
                :action="businessPlan.cta.action"
                label="Grid Business CTA Top"
                size="l"
                :to="businessPlan.cta.to"
                type="secondary"
              >
                <span>{{ businessPlan.cta.slot }}</span>
                <UiComponentIcon type="arrow-right" />
              </AtomButton>
            </UiComponentWrapper>
            <UiComponentWrapper class="plan">
              <UiComponentHeading
                as="paragraph"
                :level="4"
              >
                {{ enterprisePlan.title }}
              </UiComponentHeading>
              <AtomButton
                :action="enterprisePlan.cta.action"
                label="Grid Enterprise CTA Top"
                size="l"
                :to="enterprisePlan.cta.to"
                type="secondary"
              >
                <span>{{ enterprisePlan.cta.slot }}</span>
                <UiComponentIcon type="arrow-right" />
              </AtomButton>
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
        <UiComponentWrapper
          class="body"
          :style="{ '--top': '232px' }"
        >
          <UiComponentWrapper
            v-for="({ id, title, relatedFeatures }, index) in props.allCategoriesOfFeature"
            :key="`section-${id}`"
            class="section"
          >
            <UiComponentWrapper class="title">
              <UiComponentWrapper
                class="inner"
                @click="toggleFeatureSection(index)"
              >
                <UiComponentHeading :level="3">
                  {{ title }}
                </UiComponentHeading>
                <UiComponentIcon type="chevron-up" />
              </UiComponentWrapper>
            </UiComponentWrapper>
            <UiComponentWrapper class="related-features">
              <UiComponentWrapper
                v-for="{ id, title, description, freePlanDetails, proPlanDetails, businessPlanDetails, enterprisePlanDetails } in relatedFeatures.filter(({ displayOnPricingPage }) => displayOnPricingPage)"
                :key="`related-feature-${id}`"
                class="item"
              >
                <UiComponentWrapper
                  class="name"
                  :data-information="description"
                >
                  <UiComponentParagraph>{{ title }}</UiComponentParagraph>
                  <UiComponentIcon
                    v-if="description"
                    type="info"
                    @mouseover="onMouseOver"
                    @mouseout="onMouseOut"
                  />
                </UiComponentWrapper>
                <UiComponentWrapper
                  class="plan"
                  :data-plan="freePlan.title"
                >
                  <UiComponentIcon
                    v-if="freePlanDetails.toLowerCase() === 'no'"
                    type="x"
                  />
                  <UiComponentIcon
                    v-else-if="freePlanDetails.toLowerCase() === 'yes'"
                    type="check"
                  />
                  <UiComponentParagraph v-else>
                    {{ freePlanDetails }}
                  </UiComponentParagraph>
                </UiComponentWrapper>
                <UiComponentWrapper
                  class="plan"
                  :data-plan="proPlan.title"
                >
                  <UiComponentIcon
                    v-if="proPlanDetails.toLowerCase() === 'no'"
                    type="x"
                  />
                  <UiComponentIcon
                    v-else-if="proPlanDetails.toLowerCase() === 'yes'"
                    type="check"
                  />
                  <UiComponentParagraph v-else>
                    {{ proPlanDetails }}
                  </UiComponentParagraph>
                </UiComponentWrapper>
                <UiComponentWrapper
                  class="plan"
                  :data-plan="businessPlan.title"
                >
                  <UiComponentIcon
                    v-if="businessPlanDetails.toLowerCase() === 'no'"
                    type="x"
                  />
                  <UiComponentIcon
                    v-else-if="businessPlanDetails.toLowerCase() === 'yes'"
                    type="check"
                  />
                  <UiComponentParagraph v-else>
                    {{ businessPlanDetails }}
                  </UiComponentParagraph>
                </UiComponentWrapper>
                <UiComponentWrapper
                  class="plan"
                  :data-plan="enterprisePlan.title"
                >
                  <UiComponentIcon
                    v-if="enterprisePlanDetails.toLowerCase() === 'no'"
                    type="x"
                  />
                  <UiComponentIcon
                    v-else-if="enterprisePlanDetails.toLowerCase() === 'yes'"
                    type="check"
                  />
                  <UiComponentParagraph v-else>
                    {{ enterprisePlanDetails }}
                  </UiComponentParagraph>
                </UiComponentWrapper>
              </UiComponentWrapper>
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
        <UiComponentWrapper class="footer">
          <AtomButton
            :to="localePath('features')"
            type="text"
          >
            {{ props.page.featureTableCtaSeeAllFeatures }}
            <UiComponentIcon type="arrow-right" />
          </AtomButton>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > Reviews -->
    <UiComponentContainer class="reviews">
      <UiComponentWrapper class="badges">
        <UiComponentImage
          v-for="{ id, medal } in props.page.customerReviewsG2Badges"
          :key="`g2-badges-${id}-${badgesSize}`"
          :alt="medal.alt"
          class="badge"
          :expected-size="badgesSize"
          :extra-params="{
            trim: 'color',
          }"
          :height="medal.height"
          :orientation="medal.width >= medal.height ? 'portrait' : 'landscape'"
          :source="medal.url"
          use-natural-height
          use-natural-width
          :width="medal.width"
        />
      </UiComponentWrapper>
      <UiComponentHeading :level="2">
        {{ props.page.customerReviewsTitle }}
      </UiComponentHeading>
      <UiComponentWrapper class="rating">
        <UiComponentWrapper class="stars">
          <UiComponentWrapper
            v-for="n in 5"
            :key="`star-${n}`"
            class="star"
            :style="{
              '--rating': props.page.customerReviewsRating - n < 0 ? 1 - Math.abs(props.page.customerReviewsRating - n) : 1,
            }"
          />
        </UiComponentWrapper>
        <UiComponentHeading
          as="paragraph"
          :level="6"
        >
          {{ props.page.customerReviewsSource }}
        </UiComponentHeading>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > Testimonials -->
    <UiComponentContainer class="testimonials">
      <UiComponentWrapper class="inner">
        <UiComponentImage
          v-if="props.page.customerReviewsQuoteIllustration"
          :key="`testimonials-illustation-${testimonialIllustrationSize}`"
          :alt="props.page.customerReviewsQuoteIllustration.alt"
          class="illustration"
          :expected-size="testimonialIllustrationSize"
          :height="props.page.customerReviewsQuoteIllustration.height"
          :source="props.page.customerReviewsQuoteIllustration.url"
          :width="props.page.customerReviewsQuoteIllustration.width"
        />
        <UiComponentWrapper class="list">
          <UiComponentWrapper
            v-for="{ id, logo, quote, authorName, authorPicture, authorPosition } in props.page.customerReviewsItems"
            :key="`testimonial-${id}`"
            class="testimonial"
          >
            <UiComponentImage
              v-if="logo"
              :alt="logo.alt"
              class="logo"
              :expected-size="24"
              :extra-params="{
                trim: 'color',
              }"
              :height="logo.height"
              :orientation="logo.width >= logo.height ? 'portrait' : 'landscape'"
              :source="logo.url"
              use-natural-height
              use-natural-width
              :width="logo.width"
            />
            <UiComponentParagraph class="quote">
              {{ quote }}
            </UiComponentParagraph>
            <UiComponentWrapper class="author">
              <UiComponentImage
                v-if="authorPicture"
                :alt="authorPicture.alt"
                class="avatar"
                :expected-size="48"
                :height="authorPicture.height"
                :source="authorPicture.url"
                :width="authorPicture.width"
              />
              <UiComponentWrapper class="name">
                <UiComponentParagraph>{{ authorName }}</UiComponentParagraph>
                <UiComponentParagraph>{{ authorPosition }}</UiComponentParagraph>
              </UiComponentWrapper>
            </UiComponentWrapper>
          </UiComponentWrapper>
        </UiComponentWrapper>
      </UiComponentWrapper>
    </UiComponentContainer>

    <!-- Section > FAQ -->
    <UiComponentContainer
      class="faq"
      :start="1"
      :end="1"
    >
      <UiComponentHeading :level="2">
        {{ props.componentGlobal.faqTitle }}
      </UiComponentHeading>
      <OrganismAccordion
        class="list"
        :items="displayedFaqItems"
      />
      <AtomButton
        v-if="props.page.faqItems.length > 5"
        type="secondary"
        to="#"
        @click="toggleFaqItems"
      >
        {{
          showMoreFaqItems
            ? props.componentGlobal.faqShowLessQuestions
            : props.componentGlobal.faqShowMoreQuestions
        }}
      </AtomButton>
    </UiComponentContainer>

    <!-- Section > Get Started -->
    <UiComponentContainer class="get-started">
      <OrganismCallToAction
        :features="livestormFeatures"
        :primary-button="{
          ...signupOrUpgradeCallToAction,
          label: 'Big section CTA',
        }"
        :secondary-button="{
          ...requestDemoCallToAction,
          label: 'Big section CTA',
        }"
      >
        <template #heading>
          {{ props.componentGetStarted.title }}
        </template>
        <template #paragraph>
          {{ props.componentGetStarted.text }}
        </template>
      </OrganismCallToAction>
    </UiComponentContainer>
  </UiComponentWrapper>
</template>

<script setup>
import inEU from '@segment/in-eu'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

// Composables
const { track } = useAnalyticsJS()
const { isLogged } = useIsLoggedIn()
const localePath = useLocalePath()
const { $interpolate } = useNuxtApp()
const { public: publicRuntimeConfig } = useRuntimeConfig()
const { width: screenWidth } = useScreenSize()

// Props
const props = defineProps({
  allCategoriesOfFeature: {
    default() {
      return []
    },
    required: false,
    type: Array,
  },
  componentGetStarted: {
    required: true,
    type: Object,
  },
  componentGlobal: {
    required: true,
    type: Object,
  },
  home: {
    required: true,
    type: Object,
  },
  page: {
    required: true,
    type: Object,
  },
})

// Refs
const animatedEstimatedMonthlyActiveContacts = ref(0)
const animatedPriceWhenMonthlyBilled = ref(0)
const animatedPriceWhenYearlyBilled = ref(0)
const billingMode = ref('yearly')
const currencies = ref(['€ EUR', '$ USD'])
const currentCurrencyIndex = ref(0)
const currentProPlan = ref(null)
const displayTheFirstPopup = ref(false)
const displayTheSecondPopup = ref(false)
const firstQuestionInput = ref(0)
const fourthQuestionIndex = ref(0)
const hasInteractedWithTheCalculator = ref(false)
const intervalId = ref(null)
const secondQuestionInput = ref(0)
const showMoreFaqItems = ref(false)
const suggestedProPlan = ref(null)
const suggestions = ref([
  {
    callback: () => {
      displayTheFirstPopup.value = true
    },
    from: 'Pro 350 monthly',
    to: 'Pro 750 yearly',
  },
  {
    callback: () => {
      displayTheFirstPopup.value = true
    },
    from: 'Pro 500 monthly',
    to: 'Pro 1000 yearly',
  },
  {
    callback: () => {
      displayTheSecondPopup.value = true
    },
    from: 'Pro 750 yearly',
    to: 'Business',
  },
  {
    callback: () => {
      displayTheSecondPopup.value = true
    },
    from: 'Pro 1000 yearly',
    to: 'Business',
  },
])
const thirdQuestionIndex = ref(1)

// Variables
let matchMedia = null
let mobileFeaturesTimelines = []
let stickyOnScrollTimeline = null

// Computed Properties
const activeContactsBasedOnCalculator = computed(() => {
  const activeContacts = props.page.proPlanOptions
    .map(({ activeContactsLimit }) => activeContactsLimit)
    .reverse()
    .find(limit => estimatedMonthlyActiveContacts.value >= limit)
  return activeContacts
})

const badgesSize = computed(() => {
  return screenWidth.value < 768 ? 56 : 88
})

const bestFitBasedOnCalculator = computed(() => {
  const shouldBeSalesAssisted = fourthQuestionIndex.value > 0
  switch (true) {
    case estimatedMonthlyActiveContacts.value <= 30:
      return freePlan.value
    case estimatedMonthlyActiveContacts.value > 30 && estimatedMonthlyActiveContacts.value <= 350:
      return proPlan.value
    case estimatedMonthlyActiveContacts.value > 350 && estimatedMonthlyActiveContacts.value <= 1000:
      return shouldBeSalesAssisted ? businessPlan.value : proPlan.value
    case estimatedMonthlyActiveContacts.value > 1000 && estimatedMonthlyActiveContacts.value <= 1500:
      return businessPlan.value
    case estimatedMonthlyActiveContacts.value > 1500:
      return enterprisePlan.value
    default:
      return freePlan.value
  }
})

const bestFitTo = computed(() => {
  // return isLogged.value && bestFitBasedOnCalculator.value.id === 'pro'
  //   ? `${bestFitBasedOnCalculator.value.cta.to}&active_contact_limit=${activeContactsBasedOnCalculator.value}&cycle=${billingMode.value}`
  //   : bestFitBasedOnCalculator.value.cta.to

  return bestFitBasedOnCalculator.value.cta.to
})

const businessPlan = computed(() => {
  return {
    id: 'business',
    title: props.page.businessPlanTitle,
    text: props.page.businessPlanText,
    hasCustomPricing: true,
    activeContactsLimit: props.page.businessPlanActiveContacts,
    cta: getCallToActionByType(props.page.businessPlanCta),
    usage: props.page.businessPlanUsage,
    addons: props.page.businessPlanAddons,
    integrations: props.page.businessPlanIntegrations,
    services: props.page.businessPlanServices,
    usedBy: props.page.businessPlanUsedBy,
  }
})

const currentNumberOfActiveContacts = computed(() => {
  const closestNumberOfMonthlyActiveContactsInPlan = findClosestInArray(
    props.page.proPlanOptions.map(({ activeContactsLimit }) => activeContactsLimit),
    estimatedMonthlyActiveContacts.value,
  )
  const option = props.page.proPlanOptions
    .find(option => option.activeContactsLimit === closestNumberOfMonthlyActiveContactsInPlan)

  return option.activeContactsLimit
})

const currencySymbol = computed(() => {
  return currencies.value[currentCurrencyIndex.value].charAt(0)
})

const differenceWithTheSuggestedPlan = computed(() => {
  return (suggestedProPlan.value?.priceWhenYearlyBilled || 0) - (currentProPlan.value?.priceWhenMonthlyBilled || 0)
})

const displayedFaqItems = computed(() => {
  const index = showMoreFaqItems.value ? props.page.faqItems.length : 5
  return props.page.faqItems.slice(0, index).map(item => ({
    content: item.text,
    title: item.title,
  }))
})

const enterprisePlan = computed(() => {
  return {
    id: 'enterprise',
    title: props.page.enterprisePlanTitle,
    text: props.page.enterprisePlanText,
    hasCustomPricing: true,
    activeContactsLimit: props.page.enterprisePlanActiveContacts,
    cta: getCallToActionByType(props.page.businessPlanCta),
    usage: props.page.enterprisePlanUsage,
    addons: props.page.enterprisePlanAddons,
    integrations: props.page.enterprisePlanIntegrations,
    services: props.page.enterprisePlanServices,
    usedBy: props.page.enterprisePlanUsedBy,
  }
})

const estimatedMonthlyActiveContacts = computed(() => {
  const averageNumberOfRegistrantsPerEvent = firstQuestionInput.value
  const averageNumberOfEventsPerMonth = secondQuestionInput.value
  return Number.parseInt(
    averageNumberOfEventsPerMonth * (1 + (averageNumberOfRegistrantsPerEvent - 1) * samePeopleAttendingRatio.value),
  )
})

const firstQuestionSteps = computed(() => {
  return props.page.macCalculatorAllLevelsOfTheCursorForTheFirstQuestion.map(({ value }) => value)
})

const fourthQuestionOptions = computed(() => {
  return props.page.macCalculatorAllPossibleAnswersToTheFourthQuestion.map(({ value }) => value)
})

const freePlan = computed(() => {
  return {
    id: 'free',
    title: props.page.freePlanTitle,
    text: props.page.freePlanText,
    hasCustomPricing: false,
    activeContactsLimit: 30,
    cta: getCallToActionByType(props.page.freePlanCta),
    usage: props.page.freePlanUsage,
  }
})

const livestormFeatures = computed(() => {
  return [props.componentGlobal.noCreditCard, props.componentGlobal.noInstall]
})

const macCalculatorIllustrationOrientation = computed(() => {
  return screenWidth.value < 768 ? 'landscape' : 'portrait'
})

const macCalculatorIllustrationSize = computed(() => {
  return screenWidth.value < 768 ? screenWidth.value - 48 : 255
})

const popupCTATo = computed(() => {
  // return isLogged.value
  //   ? `${signupOrUpgradeCallToAction.value.to}&active_contact_limit=1000&cycle=yearly`
  //   : signupOrUpgradeCallToAction.value.to
  return signupOrUpgradeCallToAction.value.to
})

const priceWhenMonthlyBilled = computed(() => {
  const closestNumberOfMonthlyActiveContactsInPlan = findClosestInArray(
    props.page.proPlanOptions.map(({ activeContactsLimit }) => activeContactsLimit),
    estimatedMonthlyActiveContacts.value,
  )
  const option = props.page.proPlanOptions
    .find(option => option.activeContactsLimit === closestNumberOfMonthlyActiveContactsInPlan)

  return option.priceWhenMonthlyBilled
})

const priceWhenYearlyBilled = computed(() => {
  const closestNumberOfMonthlyActiveContactsInPlan = findClosestInArray(
    props.page.proPlanOptions.map(({ activeContactsLimit }) => activeContactsLimit),
    estimatedMonthlyActiveContacts.value,
  )
  const option = props.page.proPlanOptions
    .find(option => option.activeContactsLimit === closestNumberOfMonthlyActiveContactsInPlan)

  return option.priceWhenYearlyBilled
})

const proPlan = computed(() => {
  return {
    id: 'pro',
    title: props.page.proPlanTitle,
    text: props.page.proPlanText,
    hasCustomPricing: false,
    activeContactsLimit: props.page.proPlanActiveContacts,
    options: props.page.proPlanOptions,
    wording: {
      perMonth: props.page.proPlanPerMonth,
      billedMonthly: props.page.proPlanBilledMonthly,
      billedYearly: props.page.proPlanBilledYearly,
      saveXPercentInYearly: props.page.proPlanSaveXPercentInYearly,
      yearlyBillingOnly: props.page.proPlanYearlyBillingOnly,
    },
    cta: getCallToActionByType(props.page.proPlanCta),
    usage: props.page.proPlanUsage,
    addons: props.page.proPlanAddons,
    integrations: props.page.proPlanIntegrations,
    services: props.page.proPlanServices,
    usedBy: props.page.proPlanUsedBy,
  }
})

const requestDemoCallToAction = computed(() => {
  return {
    action: 'Demo clicked',
    slot: props.componentGlobal.contactSales,
    to: '#form-demo',
  }
})

const samePeopleAttendingRatio = computed(() => {
  if (thirdQuestionIndex.value === 1) {
    return 0.9
  }
  else if (thirdQuestionIndex.value === 2) {
    return 0.1
  }
  else {
    return 1
  }
})

const secondQuestionSteps = computed(() => {
  return props.page.macCalculatorAllLevelsOfTheCursorForTheSecondQuestion.map(({ value }) => value)
})

const signupOrUpgradeCallToAction = computed(() => {
  return isLogged.value
    ? {
        action: 'Upgrade clicked',
        to: `https://${publicRuntimeConfig.appBaseUrl}/#/settings?page=settings&tab=billing`,
        slot: props.componentGlobal.ctaUpgradeNow,
      }
    : {
        action: 'Signup clicked',
        to: `https://${publicRuntimeConfig.appBaseUrl}/#/signup`,
        slot: props.componentGlobal.ctaGetStartedForFree,
      }
})

const testimonialIllustrationSize = computed(() => {
  return screenWidth.value < 768 ? 104 : 168
})

const thirdQuestionOptions = computed(() => {
  return props.page.macCalculatorAllPossibleAnswersToTheThirdQuestion.map(({ value }) => value)
})

const wording = computed(() => {
  return {
    recalculate: props.page.macCalculatorRecalculate,
    recommendedForYou: props.page.macCalculatorRecommendedForYou,
    save: props.page.proPlanSave,
    activeContacts: props.page.plansSharedWordingActiveContactsInformation,
    usage: props.page.plansSharedWordingUsage,
    addons: props.page.plansSharedWordingAddons,
    integrations: props.page.plansSharedWordingIntegrations,
    baseIntegrations: props.page.plansSharedWordingBaseIntegrations,
    services: props.page.plansSharedWordingServices,
    usedBy: props.page.plansSharedWordingUsedBy,
  }
})

// Watchers
watch(
  () => estimatedMonthlyActiveContacts.value,
  (value) => {
    const buffer = {
      value: animatedEstimatedMonthlyActiveContacts.value,
    }

    gsap.to(buffer, {
      duration: 0.6,
      ease: 'none',
      onUpdate: () => {
        animatedEstimatedMonthlyActiveContacts.value = Number.parseInt(buffer.value)
      },
      value,
    })
  },
)

watch(
  () => priceWhenMonthlyBilled.value,
  (value) => {
    const buffer = {
      value: animatedPriceWhenMonthlyBilled.value,
    }

    if (value) {
      gsap.to(buffer, {
        duration: 0.6,
        ease: 'none',
        onUpdate: () => {
          animatedPriceWhenMonthlyBilled.value = Number.parseInt(buffer.value)
        },
        value,
      })
    }
  },
)

watch(
  () => priceWhenYearlyBilled.value,
  (value) => {
    const buffer = {
      value: animatedPriceWhenYearlyBilled.value,
    }

    gsap.to(buffer, {
      duration: 0.6,
      ease: 'none',
      onUpdate: () => {
        animatedPriceWhenYearlyBilled.value = Number.parseInt(buffer.value)
      },
      value,
    })
  },
)

// Methods
function changeCurrency(currency) {
  currentCurrencyIndex.value = currencies.value.findIndex(
    value => value === currency,
  )
}

function createMobileFeaturesTimelines() {
  mobileFeaturesTimelines = [
    ...document.querySelectorAll('.page .features .table .body .section'),
  ].map(($section, index) => {
    const timeline = gsap.timeline({
      paused: true,
    })
    timeline.from($section.querySelector('.title .inner .icon'), {
      duration: 1,
      ease: 'power3.inOut',
      rotate: -180,
    }, 0)
    timeline.from($section.querySelector('.related-features'), {
      autoAlpha: 0,
      duration: 1,
      ease: 'power3.inOut',
      height: 0,
    }, 0)
    timeline.timeScale(1.6)
    if (index === 0) {
      timeline.progress(1)
    }
    return {
      state: index === 0 ? 'reversed' : 'forward',
      timeline,
    }
  })
}

function createStickyOnTimeline() {
  stickyOnScrollTimeline = gsap.timeline({
    paused: true,
  })
  stickyOnScrollTimeline.to('.page .features .table .body', {
    '--top': '174px',
    'duration': 1.2,
    'ease': 'expo.inOut',
  }, 0)
  stickyOnScrollTimeline.to('.page .features .table .head', {
    '--bg-color': '#FFFFFF',
    'duration': 1.2,
    'ease': 'expo.inOut',
  }, 0)
  stickyOnScrollTimeline.to('.page .features .table .head .inner', {
    duration: 1.2,
    ease: 'expo.inOut',
    height: 48,
    paddingBottom: 16,
    paddingTop: 16,
  }, 0)
  stickyOnScrollTimeline.to('.page .features .table .head .inner .plan', {
    duration: 1.2,
    ease: 'expo.inOut',
    height: 48,
    paddingBottom: 0,
  }, 0)
  stickyOnScrollTimeline.to('.page .features .table .head .inner .plan .h4', {
    duration: 1.2,
    ease: 'expo.inOut',
    marginTop: 8,
  }, 0)
  stickyOnScrollTimeline.to('.page .features .table .head .inner .plan .button', {
    duration: 1.2,
    ease: 'expo.inOut',
    paddingLeft: 16,
    paddingRight: 16,
    width: 48,
    top: 0,
  }, 0)
  stickyOnScrollTimeline.fromTo('.page .features .table .head .inner .plan .button span', { translateX: 12, width: 224 }, {
    autoAlpha: 0,
    duration: 1,
    ease: 'expo.inOut',
    translateX: 0,
    width: 0,
  }, 0)
  stickyOnScrollTimeline.fromTo('.page .features .table .head .inner .plan .button .icon', { autoAlpha: 0 }, {
    autoAlpha: 1,
    duration: 1.2,
    ease: 'expo.inOut',
    marginLeft: 0,
  }, 0)
  stickyOnScrollTimeline.timeScale(2)
}

function findClosestInArray(array, goal) {
  return array
    .reduce((accumulator, current) => {
      return (Math.abs(current - goal) < Math.abs(accumulator - goal) ? current : accumulator)
    })
}

function getCallToActionByType(type) {
  return type === 'demo'
    ? requestDemoCallToAction.value
    : signupOrUpgradeCallToAction.value
}

function goToTheMacCalculator(label, position) {
  gsap.to(window, {
    duration: 1,
    ease: 'power3.inOut',
    onStart() {
      track('MAC Calculator Button clicked', {
        category: 'Button',
        label,
        position,
      })
    },
    scrollTo: {
      offsetY: screenWidth.value < 1328 ? 96 : 128,
      y: `.page .active-contacts`,
    },
  })
}

function handleAnswerTo(question, value) {
  if (!hasInteractedWithTheCalculator.value) {
    hasInteractedWithTheCalculator.value = true
  }

  switch (question) {
    case 0:
      firstQuestionInput.value = value
      break
    case 1:
      secondQuestionInput.value = value
      break
    case 2:
      thirdQuestionIndex.value = value
      break
    case 3:
      fourthQuestionIndex.value = value
      break
    default:
      return
  }
}

function hidePopups() {
  displayTheFirstPopup.value = false
  displayTheSecondPopup.value = false
}

function onEnter(el, done) {
  gsap.from(el, {
    autoAlpha: 0,
    duration: 1,
    ease: 'expo.inOut',
    onComplete() {
      done()
    },
    yPercent: 200,
  })
}

function onLeave(el, done) {
  gsap.to(el, {
    autoAlpha: 0,
    duration: 1,
    ease: 'expo.inOut',
    onComplete() {
      done()
    },
    yPercent: 200,
  })
}

function onMouseOver({ currentTarget }) {
  const { parentNode } = currentTarget
  const x = currentTarget.getBoundingClientRect().x - parentNode.getBoundingClientRect().x
  parentNode.style.setProperty('--left', `${x + 8}px`)
  parentNode.classList.add('hoverable')
}

function onMouseOut({ currentTarget }) {
  currentTarget.parentNode.classList.remove('hoverable')
}

function onScroll() {
  if (!stickyOnScrollTimeline) {
    createStickyOnTimeline()
  }
  const $el = document.querySelector('.page .features .table .head')
  const stickyTop = parseInt(window.getComputedStyle($el).top)
  const currentTop = $el.getBoundingClientRect().top
  const methods = currentTop === stickyTop ? 'play' : 'reverse'
  stickyOnScrollTimeline[methods]()
}

function planChanged(value) {
  clearInterval(intervalId.value)
  intervalId.value = null

  const key = `Pro ${value} ${billingMode.value}`
  const suggestion = suggestions.value.find(({ from }) => from === key)

  if (suggestion) {
    currentProPlan.value = proPlan.value.options.find(({ activeContactsLimit }) => activeContactsLimit === Number.parseInt(suggestion.from.split(' ')[1]))
    suggestedProPlan.value = proPlan.value.options.find(({ activeContactsLimit }) => activeContactsLimit === Number.parseInt(suggestion.to.split(' ')[1]))

    intervalId.value = window.setTimeout(() => {
      suggestion.callback()
    }, 800)
  }

  track('Active contacts slider clicked', {
    category: 'Slider',
    label: 'Header slider',
    MAC: value,
  })
}

function setBillingMode(value) {
  billingMode.value = value
  hidePopups()
}

function toggleBillingMode() {
  billingMode.value = billingMode.value === 'yearly' ? 'monthly' : 'yearly'
  hidePopups()
}

function toggleFaqItems() {
  showMoreFaqItems.value = !showMoreFaqItems.value
}

function toggleFeatureSection(index) {
  if (mobileFeaturesTimelines[index].state === 'forward') {
    mobileFeaturesTimelines[index].state = 'reversed'
    mobileFeaturesTimelines[index].timeline.play()
  }
  else {
    mobileFeaturesTimelines[index].state = 'forward'
    mobileFeaturesTimelines[index].timeline.reverse()
  }
}

function wrapWithCurrency(currency, value) {
  return currency === '€' ? `${value}${currency}` : `${currency}${value}`
}

// Lifecycle Hooks
onBeforeUnmount(() => {
  gsap.set('html, body, .app__layout-footer', {
    clearProps: 'background',
  })
  if (intervalId.value) {
    clearInterval(intervalId.value)
    intervalId.value = null
  }
  mobileFeaturesTimelines.forEach(el => el.timeline.kill())
  mobileFeaturesTimelines = []
  stickyOnScrollTimeline?.kill()
  stickyOnScrollTimeline = null
  window.removeEventListener('scroll', onScroll)
})

onBeforeMount(() => {
  animatedPriceWhenMonthlyBilled.value = priceWhenMonthlyBilled.value
  animatedPriceWhenYearlyBilled.value = priceWhenYearlyBilled.value

  gsap.set('html, body', {
    background: '#F9FAFB',
  })
  gsap.set('.app__layout-footer', {
    background: 'transparent',
  })
})

onMounted(() => {
  if (!inEU()) {
    currentCurrencyIndex.value = 1
  }

  firstQuestionInput.value = firstQuestionSteps.value[0]
  secondQuestionInput.value = secondQuestionSteps.value[0]
  window.addEventListener('scroll', onScroll)

  matchMedia = gsap.matchMedia()
  matchMedia.add(
    '(max-width: 1327px)',
    () => {
      createMobileFeaturesTimelines()
    },
  )
})
</script>

<style lang="postcss" scoped>
.page {
  @apply flex-col items-center -mt-14 pt-14 bg-[#F9FAFB] overflow-hidden;

  @screen md {
    @apply -mt-[72px] pt-[72px] overflow-visible;
  }

  .popup {
    @apply hidden;

    @screen xl {
      @apply fixed bottom-6 flex justify-center z-50;
    }

    .inner {
      @apply relative items-center justify-between max-w-[1328px] w-full pl-8 pt-8 pr-18 pb-8 bg-livestorm-blue-700 rounded-4xl;

      .details {
        @apply gap-3 w-auto max-w-[904px];

        .icon {
          @apply py-1 text-white text-2xl leading-none;
        }

        .content {
          @apply flex-col;

          p {
            @apply text-white text-base leading-7;

            &.headline {
              @apply font-medium mb-1 text-2xl leading-8;
            }
          }

          .more {
            @apply relative gap-20 mt-8 pb-[30px];

            .arrow {
              @apply absolute bottom-0 left-1/2 transform -translate-x-1/2;
            }

            .current-plan,
            .suggested-plan {
              @apply flex-col gap-2;

              .body {
                @apply justify-between;

                .h6 {
                  @apply text-white;

                  :deep(strong) {
                    @apply font-normal text-[11px] text-white leading-[normal];
                  }
                }
              }

              .footer {
                @apply relative h-2 w-[372px] bg-grey-blue-200 rounded-xs overflow-hidden;

                .progress {
                  @apply absolute left-0 top-0 w-0 h-full bg-spring-green-500;
                }
              }
            }

            .suggested-plan {
              .footer {
                .progress {
                  @apply bg-spring-green-700;
                }
              }
            }
          }
        }
      }

      .action {
        @apply w-auto;
      }

      .close {
        @apply absolute right-8 top-8 w-auto p-1 cursor-pointer transform rotate-0 transition-transform duration-500 ease-in-out;

        &:hover {
          @apply rotate-90;
        }

        .icon {
          @apply text-base text-white leading-none;
        }
      }
    }
  }

  .hero {
    @apply flex-col gap-4 mt-10;

    @screen md {
      @apply mt-16;
    }

    .h1 {
      @apply font-normal text-3xl leading-10;

      @screen mdminus {
        @apply text-5xl leading-16;
      }

      @screen mdplus {
        @apply text-6xl leading-20;
      }
    }

    .h1,
    p {
      @apply self-center text-center;
    }

    p {
      @apply text-grey-blue-600;
    }
  }

  .paid-plans {
    @apply flex-col gap-6 mt-10;

    @screen md {
      @apply gap-8 mt-16;
    }

    .filters {
      @apply items-center justify-center;

      @screen md {
        @apply justify-between;
      }

      .switch {
        @apply flex-row gap-2 w-auto;

        .toggle {
          @apply gap-2 w-auto;

          p {
            @apply font-medium text-grey-blue-600 text-sm leading-6 cursor-pointer transition-colors duration-500 ease-in-out;

            &.active {
              @apply text-winter-green-900 cursor-default;
            }
          }

          .widget {
            @apply relative h-6 w-10 bg-white border border-grey-blue-200 rounded-3xl cursor-pointer;

            &::before {
              @apply absolute left-0 top-0 h-4 w-4 ml-[3px] mt-[3px] bg-livestorm-blue-700 rounded-full shadow-light2 transition-transform duration-500 ease-in-out content-[''];
            }

            &.on {
              &::before {
                @apply translate-x-4;
              }
            }
          }
        }

        .discount {
          @apply self-center w-auto px-2 py-1 border border-spring-green-800 font-medium text-spring-green-800 text-xs leading-4 rounded-xs;
        }
      }

      .currencies {
        @apply hidden;

        @screen md {
          @apply flex w-auto;
        }

        .select {
          @apply self-start w-auto;

          :deep(select) {
            @apply h-9 w-[110px] bg-white border-2 border-grey-blue-200 font-medium text-grey-blue-600 text-sm leading-8 rounded;
          }

          :deep(.icon) {
            @apply h-9 text-winter-green-900 text-sm leading-8 z-0 !important;
          }
        }
      }
    }

    .plans {
      @apply flex-col gap-10;

      @screen xl {
        @apply flex-row flex-nowrap;
      }
    }

    .mobile-only {
      @apply justify-end mt-4;

      @screen md {
        @apply hidden;
      }

      .select {
        @apply self-start w-auto;

        :deep(select) {
          @apply h-9 w-[110px] bg-white border-2 border-grey-blue-200 font-medium text-grey-blue-600 text-sm leading-8 rounded;
        }

        :deep(.icon) {
          @apply h-9 text-winter-green-900 text-sm leading-8 z-0 !important;
        }
      }
    }
  }

  .active-contacts {
    @apply flex-col gap-10 mt-20;

    @screen md {
      @apply mt-34 gap-12;
    }

    @screen xl {
      @apply flex-row flex-wrap items-center justify-between gap-10;
    }

    .definition {
      @apply flex-col gap-4;

      @screen xl {
        @apply w-span4;
      }

      .head {
        @apply self-start w-auto p-4 bg-blizzard-100 border border-blizzard-200 rounded;

        .icon {
          @apply text-blizzard-800 text-2xl leading-none;
        }
      }

      .body {
        @apply flex-col gap-2;

        .h2 {
          @apply font-medium text-2xl leading-8;

          @screen mdminus {
            @apply text-[28px] leading-[34px];
          }

          @screen mdplus {
            @apply text-3xl leading-10;
          }
        }

        p {
          @apply text-grey-blue-600;
        }
      }

      .footer {
        @apply gap-2 mt-2 p-5 bg-blizzard-100 border-2 border-blizzard-200 rounded-2xl;

        .icon {
          @apply text-blizzard-600 text-base leading-none;
        }

        .examples {
          @apply flex-col gap-0.5;

          .title {
            @apply font-medium text-sm leading-4;
          }

          .list {
            @apply flex-col;

            .item {
              @apply font-normal text-grey-blue-600 text-sm leading-[22px];

              &::before {
                @apply px-2 content-['•'];
              }
            }
          }
        }
      }
    }

    .calculator {
      @apply flex-col bg-white border-2 border-grey-blue-200 rounded-3xl overflow-hidden;

      @screen xl {
        @apply flex-row items-stretch w-span8 h-[504px];
      }

      .questions {
        @apply flex-col w-full p-6 pb-8;

        @screen md {
          @apply p-12 pb-8;
        }

        @screen xl {
          @apply self-center max-w-[440px] pb-14;
        }

        .question {
          @apply flex-col mt-6;

          p {
            @apply font-medium text-black text-sm leading-[22px];
          }

          .range {
            :deep(.slider) {
              .progress {
                @apply bg-blizzard-500;
              }
            }
          }

          .select {
            @apply bg-blizzard-100;

            :deep(.option) {
              &.active {
                @apply text-blizzard-600;
              }
            }
          }
        }
      }

      .result {
        @apply min-h-[462px] w-full bg-blizzard-700;

        @screen md {
          @apply min-h-[470px];
        }

        @screen xl {
          @apply min-h-[unset] max-w-[400px] h-auto m-0 rounded-none;
        }

        .inner {
          @apply flex-col;

          .illustation {
            @apply self-center mt-auto;

            @screen xl {
              @apply mt-[114px];
            }

            & + p {
              @apply self-center max-w-[316px] mb-auto font-medium text-center text-white text-xl leading-normal;
            }
          }

          .estimation {
            @apply flex-col items-center py-4 bg-blizzard-800/30;

            p {
              @apply w-full font-medium text-base text-center text-white leading-7;

              & + p {
                @apply relative inline-flex justify-center items-center mt-1;

                .count {
                  @apply font-bold text-[22px];
                }

                .keyword {
                  @apply relative ml-1;
                }

                .info {
                  @apply relative inline-flex ml-[7px] w-auto;

                  .icon {
                    @apply text-white;
                  }
                }
              }
            }
          }

          .plan {
            @apply flex-col h-full p-8 pt-6;

            @screen xl {
              @apply w-100;
            }

            .name {
              @apply font-medium text-white text-2xl;
            }

            .type {
              @apply mt-2;

              @screen md {
                @apply mt-4;
              }

              &.free {
                @apply items-center;

                .price {
                  @apply font-medium font-sans text-white text-5xl leading-[1.2];
                }

                .info {
                  @apply flex-col ml-1;

                  p {
                    @apply font-normal text-white text-[13px] leading-[1.2];

                    & + p {
                      @apply mt-1;
                    }
                  }
                }
              }

              &.sales-enabled {
                @apply font-medium text-white text-3xl leading-[1.2];
              }

              &.self-service {
                @apply flex-col gap-4;

                .monthly,
                .yearly {
                  @apply items-center gap-1;

                  .annual-only {
                    @apply text-white text-sm leading-6;
                  }

                  .price {
                    @apply font-bold text-white text-2xl;
                  }

                  .info {
                    @apply flex-col;

                    p {
                      @apply text-white text-[11px] leading-[normal];
                    }
                  }
                }
              }
            }

            .usage {
              @apply flex-col mt-2;

              @screen xl {
                @apply my-4;
              }

              .feature {
                @apply relative inline-flex items-start gap-2;

                &::after {
                  @apply absolute left-[var(--left)] -top-1 h-5 w-5 bg-grey-blue-100 rounded-md transform origin-center -translate-x-1/2 -translate-y-3/4 rotate-45 opacity-0 invisible transition-all duration-300 ease-in-out content-[''];
                }

                &::before {
                  @apply absolute -top-1 px-6 py-[14px] bg-grey-blue-100 text-winter-green-900 text-center text-sm leading-6 rounded shadow-light4 transform -translate-y-full opacity-0 invisible transition-all duration-300 ease-in-out content-[attr(data-information)];
                }

                &.hoverable {
                  &::after,
                  &::before {
                    @apply opacity-100 visible;
                  }
                }

                .icon {
                  @apply text-base leading-none transform translate-y-1;

                  &.icon-check,
                  &.icon-plus {
                    @apply font-bold text-white !important;
                  }

                  &.icon-info {
                    @apply text-white !important;
                  }
                }

                p {
                  @apply font-normal text-white text-sm leading-6;

                  :deep(strong) {
                    @apply text-white;
                  }
                }
              }
            }

            .button {
              @apply mt-10 bg-white text-winter-green-900;

              @screen xl {
                @apply mt-auto;
              }
            }
          }
        }
      }
    }
  }

  .free-plan {
    @apply mt-20;

    @screen md {
      @apply mt-34;
    }

    .inner {
      @apply flex-col gap-8 p-6 bg-white border-2 border-grey-blue-200 rounded-3xl;

      @screen md {
        @apply flex-row flex-wrap justify-between gap-0 p-10;
      }

      .head {
        @apply flex-col gap-1;

        @screen md {
          @apply w-auto;
        }

        .h2 {
          @apply font-medium text-2xl leading-8;

          @screen mdminus {
            @apply text-[28px] leading-[34px];
          }

          @screen mdplus {
            @apply text-3xl leading-10;
          }
        }

        .h3 {
          @apply text-origin leading-7;

          @screen mdminus {
            @apply text-xl;
          }

          @screen mdplus {
            @apply text-xl;
          }
        }
      }

      .body {
        @apply flex-col gap-2;

        @screen md {
          @apply max-w-[222px];
        }

        .feature {
          @apply relative inline-flex items-start gap-1;

          &::after {
            @apply absolute left-[var(--left)] -top-[8px] h-5 w-5 bg-grey-blue-100 rounded-md transform origin-center -translate-x-1/2 -translate-y-3/4 rotate-45 opacity-0 invisible transition-all duration-500 ease-in-out content-[''];
          }

          &::before {
            @apply absolute -top-[8px] px-6 py-[14px] bg-grey-blue-100 text-winter-green-900 text-center text-sm leading-6 rounded shadow-light4 transform -translate-y-full opacity-0 invisible transition-all duration-500 ease-in-out content-[attr(data-information)];
          }

          &.hoverable {
            &::after,
            &::before {
              @apply opacity-100 visible;
            }
          }

          .icon {
            @apply text-grey-blue-600 text-base leading-none transform translate-y-1 !important;

            &.icon-check {
              @apply font-bold text-livestorm-blue-700 !important;
            }
          }

          p {
            @apply ml-1 font-normal text-grey-blue-600 text-sm leading-6;

            :deep(strong) {
              @apply text-grey-blue-800;
            }
          }
        }
      }

      .footer {
        @apply flex-col gap-4;

        @screen md {
          @apply max-w-[242px];
        }

        .list {
          @apply flex-col gap-2;

          .feature {
            @apply inline-flex items-start gap-2;

            .icon {
              @apply font-bold text-livestorm-blue-700 text-base leading-none transform translate-y-1 !important;
            }

            p {
              @apply font-normal text-grey-blue-600 text-sm leading-6;

              :deep(strong) {
                @apply text-grey-blue-800;
              }
            }
          }
        }
      }
    }
  }

  .features {
    @apply flex-col items-center gap-10 mt-20;

    @screen md {
      @apply mt-34;
    }

    .h2 {
      @apply text-center;
    }

    .table {
      @apply flex-col;

      @screen xl {
        @apply relative;
      }

      .head {
        @apply hidden;

        @screen xl {
          @apply sticky top-[72px] flex z-20;
        }

        .inner {
          @apply relative flex flex-nowrap gap-10 py-6 bg-[var(--bg-color)] box-content;

          &::before,
          &::after {
            width: calc((100vw - 1280px) / 2);
          }

          &::before {
            @apply absolute top-0 h-full bg-[var(--bg-color)] content-[''];
            left: calc((100vw - 100%) / -2);
          }

          &::after {
            @apply absolute top-0 h-full bg-[var(--bg-color)] content-[''];
            right: calc((100vw - 100%) / -2);
          }

          .empty,
          .plan {
            @apply relative flex-col pb-16;

            .button {
              @apply absolute top-12 right-0 w-full;

              :deep(span) {
                @apply inline-flex justify-center text-center;
              }
            }
          }
        }
      }

      .body {
        @apply flex-col gap-12 pt-4;

        @screen xl {
          @apply relative gap-16;
        }

        &::after {
          @screen xl {
            @apply absolute bottom-0 h-48 w-full bg-gradient-to-b from-transparent to-[#F9FAFB] content-[''];
          }
        }

        .section {
          @apply flex-col;

          .title {
            @apply sticky top-20 pb-6 bg-[#F9FAFB] border-b border-grey-blue-200 z-10;

            @screen xl {
              @apply top-[var(--top)];
            }

            .inner {
              @apply relative items-center justify-between;

              &::before {
                @apply absolute -top-6 left-0 right-0 flex h-6 bg-[#F9FAFB] content-[''];
              }

              .h3 {
                @apply text-origin leading-7;

                @screen mdminus {
                  @apply text-xl;
                }

                @screen mdplus {
                  @apply text-xl;
                }
              }

              .icon {
                @screen xl {
                  @apply hidden;
                }
              }
            }
          }

          .related-features {
            @apply flex-col;

            .item {
              @apply flex-col py-4 border-t border-grey-blue-200;

              &:first-child {
                @apply border-none;
              }

              @screen xl {
                @apply flex-row flex-nowrap items-center gap-10 py-6;
              }

              .name {
                @apply relative items-center gap-2 mb-4;

                @screen xl {
                  @apply mb-0;
                }

                &::after {
                  @apply absolute left-[var(--left)] -top-1 h-5 w-5 bg-grey-blue-100 rounded-md transform origin-center -translate-x-1/2 -translate-y-3/4 rotate-45 opacity-0 invisible content-[''] z-30;
                }

                &::before {
                  @apply absolute right-0 -top-1 px-6 py-[14px] bg-grey-blue-100 text-winter-green-900 text-center text-sm leading-6 rounded shadow-light4 transform -translate-y-full opacity-0 invisible content-[attr(data-information)] z-30;

                  @screen xl {
                    @apply -right-[12px];
                  }
                }

                &.hoverable {
                  &::after,
                  &::before {
                    @apply opacity-100 visible;
                  }
                }

                p {
                  @apply text-winter-green-900 text-base leading-6;

                  @screen xl {
                    @apply text-grey-blue-600;
                  }
                }

                .icon {
                  @apply text-base text-grey-blue-600 leading-none;
                }
              }

              .plan {
                @apply flex-nowrap gap-10 mb-3;

                @screen xl {
                  @apply justify-center gap-0 mb-0;
                }

                &:last-child {
                  @apply mb-0;
                }

                &::before {
                  @apply flex w-full font-normal text-grey-blue-600 text-sm leading-6 content-[attr(data-plan)];

                  @screen xl {
                    @apply hidden content-none;
                  }
                }

                p {
                  @apply w-full text-grey-blue-600 text-sm leading-6;

                  @screen xl {
                    @apply w-auto text-center text-base;
                  }
                }

                .icon {
                  @apply w-full text-xl leading-none;

                  @screen xl {
                    @apply w-auto;
                  }

                  &.icon-check {
                    @apply text-spring-green-700;
                  }

                  &.icon-x {
                    @apply text-grey-blue-300;
                  }
                }
              }
            }
          }
        }
      }

      .footer {
        @apply hidden;

        @screen xl {
          @apply flex flex-col items-center;

          .button {
            @apply self-center h-[50px] px-0 font-bold;
          }
        }
      }
    }
  }

  .reviews {
    @apply flex-col mt-26;

    @screen md {
      @apply mt-46;
    }

    .badges {
      @apply justify-center gap-2;

      @screen md {
        @apply gap-4;
      }

      .badge {
        @apply rounded-none;
      }
    }

    .h2 {
      @apply self-center max-w-[1060px] mt-4 text-center;
    }

    .rating {
      @apply flex-col items-center mt-4;

      .stars {
        @apply justify-between w-[113px];

        .star {
          @apply relative w-5 h-5 bg-grey-blue-300;
          mask-image: url(@/assets/svg/star-rounded.svg);
          mask-repeat: no-repeat;
          mask-size: 20px;

          &::after {
            @apply absolute h-5 bg-sandstorm-yellow-600 content-[''];
            width: calc(var(--rating) * 100%);
          }
        }
      }

      .h6 {
        @apply mt-3 font-normal text-base text-center leading-[21px];

        :deep(strong) {
          @apply text-winter-green-900;
        }
      }
    }
  }

  .testimonials {
    @apply mt-12;

    .inner {
      @apply relative p-8 bg-white border border-grey-blue-200 rounded-3xl;

      @screen md {
        @apply p-14;
      }

      @screen xl {
        @apply pb-16;
      }

      .illustration {
        @apply absolute right-5 top-0 transform -translate-y-1/2;

        @screen md {
          @apply right-8;
        }
      }

      .list {
        @apply flex-col gap-[72px];

        @screen md {
          @apply gap-[88px];
        }

        @screen xl {
          @apply flex-row flex-nowrap gap-10;
        }

        .testimonial {
          @apply flex-col gap-6;

          .logo {
            @apply rounded-none;
          }

          .quote {
            @apply text-grey-blue-600 text-base leading-6;
          }

          .author {
            @apply gap-4;

            .avatar {
              @apply rounded-full;
            }

            .name {
              @apply flex-col;

              p {
                @apply text-winter-green-900 text-base leading-6;

                & + p {
                  @apply text-grey-blue-600
                }
              }
            }
          }
        }
      }
    }
  }

  .faq {
    @apply flex-col gap-8 mt-26;

    @screen md {
      @apply mt-46;
    }

    .h2 {
      @apply self-center text-center;
    }

    .button {
      @apply self-center mt-8;
    }
  }

  .get-started {
    @apply mt-26;

    @screen md {
      @apply mt-46;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  @apply transition-opacity duration-500 ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  @apply opacity-0;
}
</style>
